import * as ramda from 'ramda';

import {sortByPosition} from 'nutshell-core/utils/sorting/sort-by-position';

import type {EmailComposerFormSequenceState, EmailComposerFormTemplate} from './types';

export function modifyReplySubjects(
    sequence: EmailComposerFormSequenceState
): EmailComposerFormSequenceState {
    return {
        ...sequence,
        emailTemplates: replaceSubjectsForReplies(sequence.emailTemplates),
    };
}

function replaceSubjectsForReplies(templates: {[templateId: string]: EmailComposerFormTemplate}) {
    const sortedTemplates = sortByPosition(templates);

    return ramda.mapObjIndexed((template) => {
        if (!template.sendAsReply) {
            return template;
        }

        const index = sortedTemplates.findIndex((t) => t.id === template.id);
        const previousSubject = getPreviousRealSubject(sortedTemplates, index);

        return {
            ...template,
            subject: `Re: ${previousSubject}`,
        };
    }, templates);
}

function getPreviousRealSubject(
    templates: EmailComposerFormTemplate[],
    currentIndex: number
): string {
    let index = currentIndex;
    let sendAsReply;
    do {
        index--;
        // @ts-expect-error
        sendAsReply = templates[index].sendAsReply;
    } while (sendAsReply && index > 0);

    // @ts-expect-error
    return templates[index].subject || '';
}
